import produce from 'immer';
import {
    SET_IS_CHAT_ENABLED,
    SET_CS_ORDERS
} from '../constants';

const initialState = {
    isChatEnabled: false,
    isDependenciesFetchComplete: false,
    customer: null,
    orders: []
};

const CSReducer = produce((state, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_IS_CHAT_ENABLED: {
            state.isChatEnabled = payload;
            break;
        }

        case SET_CS_ORDERS: {
            state.orders = payload;
            break;
        }

        // skip default
    }
}, initialState);

export default CSReducer;
